import React from 'react';
import Box from '@mui/material/Box';
import LandingAppBar from './LandingAppBar';
import HeroSection from './HeroSection';
import WaitlistSection from './WaitlistSection';
import LandingFooter from './LandingFooter';

export default function LandingPage() {
  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh' }}>
      <LandingAppBar />
      <main>
        <HeroSection />
        <WaitlistSection />
      </main>
      <LandingFooter />
    </Box>
  );
}
